<div
  *ngIf="services?.length || isLoading"
  class="container"
  style="margin-bottom: var(--mb-60)"
>
  <div class="multi-item-carousel-wrapper">
    <!-- Carousel heading section -->
    <div class="carousel-heading">
      <h2 class="main-heading">
        {{ heading | translate }}
      </h2>
      <p class="mb-0">
        {{ subHeading | translate }}
      </p>
    </div>

    <!-- Carousel for skeleton loaders -->
    <swiper *ngIf="isLoading; else serviceCard" [config]="serviceSliderConfig">
      <ng-container *ngFor="let loader of loadingSrvs; let i = index">
        <ng-template swiperSlide>
          <div class="service-card">
            <div class="service-card__body cursor-pointer">
              <app-skeleton-loader
                skeletonLoaderClass="skeleton--sevice-card w-100"
                [isHorizontal]="false"
              ></app-skeleton-loader>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </swiper>

    <!-- Carousel for services -->
    <ng-template #serviceCard>
      <swiper [config]="serviceSliderConfig" class="multi-slides">
        <ng-container *ngFor="let service of services">
          <ng-template swiperSlide>
            <div class="service-card">
              <div
                class="service-card__body cursor-pointer"
                (click)="
                  onServiceCardClick(
                    service[
                      heading.includes('popular') ? 'dept_name' : srvNameKey
                    ],
                    service
                  )
                "
              >
                <div class="service-card__body__img">
                  <img
                    imgFallback
                    [imgLazyLoad]="service[logoUrlKey]"
                    fetchPriority="low"
                    width="90"
                    height="90"
                    [alt]="service[srvNameKey]"
                  />
                </div>
                <div class="service-card__body__content">
                  <h4 class="mb-2">
                    <span>{{ service[displayKey] || "N.A." }}</span>
                  </h4>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </swiper>
    </ng-template>
  </div>
</div>
